export const getDisplayDate = (date?: Date) =>
  date !== undefined
    ? new Date(date).toLocaleDateString(undefined, {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "";
